// ** React Imports
import { useCallback, useRef } from "react";

// ** Redux & Store & Actions
import { useDispatch } from "react-redux";
import { setGeolocation } from "store/modules/global";

// #####################################################

const useGeolocation = () => {
	const dispatch = useDispatch();

	const coordinatesRef = useRef({
		accuracy: null,
		latitude: null,
		longitude: null,
		timestamp: null,
		error: null,
	});

	const updateCoordinates = useCallback(({ coords, timestamp, callback }) => {
		const { accuracy, latitude, longitude } = coords;

		const result = {
			accuracy,
			latitude,
			longitude,
			timestamp,
			error: null,
		};

		coordinatesRef.current = result;
		if (latitude && longitude) {
			dispatch(setGeolocation(result));
		}

		if (typeof callback === "function") {
			callback(latitude, longitude);
		}
	}, []);

	const setError = useCallback(({ error }) => {
		const result = {
			accuracy: null,
			latitude: null,
			longitude: null,
			timestamp: null,
			error,
		};

		coordinatesRef.current = result;
		dispatch(setGeolocation(result));
	}, []);

	const getGeolocation = (callback, onError) => {
		if (navigator.geolocation) {
			navigator.geolocation.getCurrentPosition(
				(result) => {
					return updateCoordinates({
						coords: result.coords,
						timestamp: result.timestamp,
						callback,
					});
				},
				(error) => {
					typeof onError === "function" && onError(error);
					return setError({ error });
				}
			);
		} else {
			typeof onError === "function" && onError();
			setError({
				error: "Geolocation is not supported by this browser.",
			});
		}
	};

	// #####################################################

	return {
		getGeolocation,
		coordinates: {
			...coordinatesRef.current,
		},
	};
};

// #####################################################

export default useGeolocation;

// #####################################################
